/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	Internship,
	InternshipFromJSON,
	InternshipFromJSONTyped,
	InternshipToJSON,
} from "./Internship";
import {
	StudyProgram,
	StudyProgramFromJSON,
	StudyProgramFromJSONTyped,
	StudyProgramToJSON,
} from "./StudyProgram";

/**
 *
 * @export
 * @interface InternshipStudyProgram
 */
export interface InternshipStudyProgram {
	/**
	 *
	 * @type {string}
	 * @memberof InternshipStudyProgram
	 */
	id?: string;
	/**
	 *
	 * @type {Date}
	 * @memberof InternshipStudyProgram
	 */
	createdAt?: Date;
	/**
	 *
	 * @type {Date}
	 * @memberof InternshipStudyProgram
	 */
	updatedAt?: Date;
	/**
	 *
	 * @type {string}
	 * @memberof InternshipStudyProgram
	 */
	internshipId?: string;
	/**
	 *
	 * @type {string}
	 * @memberof InternshipStudyProgram
	 */
	studyProgramId?: string;
	/**
	 *
	 * @type {boolean}
	 * @memberof InternshipStudyProgram
	 */
	approved?: boolean;
	/**
	 *
	 * @type {Internship}
	 * @memberof InternshipStudyProgram
	 */
	internship?: Internship;
	/**
	 *
	 * @type {StudyProgram}
	 * @memberof InternshipStudyProgram
	 */
	studyProgram?: StudyProgram;
}

export function InternshipStudyProgramFromJSON(
	json: any
): InternshipStudyProgram {
	return InternshipStudyProgramFromJSONTyped(json, false);
}

export function InternshipStudyProgramFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InternshipStudyProgram {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		id: !exists(json, "id") ? undefined : json["id"],
		createdAt: !exists(json, "createdAt")
			? undefined
			: new Date(json["createdAt"]),
		updatedAt: !exists(json, "updatedAt")
			? undefined
			: new Date(json["updatedAt"]),
		internshipId: !exists(json, "internshipId")
			? undefined
			: json["internshipId"],
		studyProgramId: !exists(json, "studyProgramId")
			? undefined
			: json["studyProgramId"],
		approved: !exists(json, "approved") ? undefined : json["approved"],
		internship: !exists(json, "internship")
			? undefined
			: InternshipFromJSON(json["internship"]),
		studyProgram: !exists(json, "studyProgram")
			? undefined
			: StudyProgramFromJSON(json["studyProgram"]),
	};
}

export function InternshipStudyProgramToJSON(
	value?: InternshipStudyProgram | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		id: value.id,
		createdAt:
			value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
		updatedAt:
			value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
		internshipId: value.internshipId,
		studyProgramId: value.studyProgramId,
		approved: value.approved,
		internship: InternshipToJSON(value.internship),
		studyProgram: StudyProgramToJSON(value.studyProgram),
	};
}
